import * as React from 'react';
import {Dialog} from 'material-ui';
import {UserModel} from '../../model/UserModel';
import {deactivateUser} from '../../services/userService';
import {IHistory} from '../../interfaces';
import {Loader} from '../reusableComponents/Loader/Loader';
import {CustomFlatButton} from '../reusableComponents/CutomFlatButton';

export interface IDeleteUserDialogProps {
    instance: UserModel;
    onClose: Function;
    open: boolean;
    userStatus?: boolean;
    history: IHistory;
}

export interface IDeleteUserDialogState {
    open: boolean;
    isLoading: boolean;
}

export class DeleteUserDialog extends React.PureComponent<IDeleteUserDialogProps, IDeleteUserDialogState> {
    constructor(props: IDeleteUserDialogProps) {
        super(props);
        this.state = {open: false, isLoading: false};
    }

    public componentWillReceiveProps(nextProps: IDeleteUserDialogProps) {
        this.setState({
            open: nextProps.open
        });
    }

    public handleClose = () => {
        this.setState({
            open: false
        });
        this.props.onClose();
    }

    public handleUserDelete = async () => {
        const {UniqueID, FirstName} = this.props.instance.props;
        try {
            this.setState({isLoading: true});
            await deactivateUser(UniqueID, FirstName, this.props.userStatus, this.props.history);
            this.setState({open: false, isLoading: false});
        } catch (error) {
            this.setState({open: false, isLoading: false});
            throw error;
        }
    }

    public render() {
        if (!this.props.instance) {
            return '';
        }
        return <Dialog
            title={`Do you really want to ${this.props.userStatus ? 'activate' : 'deactivate'} ${this.props.instance.props.FirstName}'s account?`}
            modal={false}
            className="url-modal"
            open={this.state.open}
            actions={
                [
                    <CustomFlatButton
                        label="No"
                        color={'black'}
                        primary={true}
                        onClick={this.handleClose}
                    />,
                    <CustomFlatButton
                        label="Yes"
                        color={'black'}
                        primary={true}
                        onClick={this.handleUserDelete}
                    />
                ]
            }
            onRequestClose={this.handleClose}
        >
            {this.state.isLoading ? <Loader type="submission"/> : ''}
            Click yes to proceed or No to cancel
        </Dialog>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Users/DeleteUserDialog.tsx